export const getters = {
    LIST: (state) => state.faqCategories,
}